import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const DRAFT_KEY = "dropit_pending_dispatch";
const MAX_AGE = 7 * 24 * 3600 * 1000;
export const HANDOFF_PATH = "/app/new?fromSandbox=1";

/* Simulated presets: fake-but-plausible NZ coords (never used as a real pin). */
export const PRESETS = [
  { id: "gate3", title: "Gate 3 / Back Paddock", lat: -37.78712, lng: 175.27934, task: "Unload 2 pallets of 100x50 timber near main shed.", access: "Key code 4821 on lockbox.", hazards: ["Stock in paddock", "Soft ground near gate"], short: "Unload timber" },
  { id: "roof", title: "124 Commercial St – Roof Area", lat: -36.84846, lng: 174.76334, task: "Replace 2 cracked skylight panels; photos of flashing.", access: "Site office has roof hatch key.", hazards: ["Working at height", "Fragile roof panels"], short: "Replace skylight panels" },
  { id: "pickup", title: "Hardware Store Pickup", lat: -43.53205, lng: 172.63622, task: "Collect order #4471: 20 bags cement, 6 sheets ply.", access: "Trade account — ask for Dave.", hazards: ["Heavy lifting"], short: "Collect order #4471" },
];
export const presetById = (id) => PRESETS.find((p) => p.id === id) || PRESETS[0];

export const saveSandboxDraft = (d) => localStorage.setItem(DRAFT_KEY, JSON.stringify({ ...d, savedAt: Date.now() }));
export const getSandboxDraft = () => {
  try {
    const d = JSON.parse(localStorage.getItem(DRAFT_KEY) || "null");
    if (!d || typeof d !== "object" || !d.locationTitle || !d.voiceText?.task || Date.now() - (d.savedAt || 0) > MAX_AGE) return null;
    return d;
  } catch { return null; }
};
export const clearSandboxDraft = () => localStorage.removeItem(DRAFT_KEY);

/* "Unload timber – Gate 3 / Back Paddock" */
export const deriveTitle = (d) => `${presetById(d.preset).short || d.voiceText.task.split(/[;.]/)[0]} – ${d.locationTitle}`;

/* Signed in + a pending sandbox draft + sitting on a public page → send them to the real form. */
export const useSandboxHandoff = () => {
  const { session } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  useEffect(() => {
    if (session && getSandboxDraft() && (pathname === "/" || pathname === "/auth")) navigate(HANDOFF_PATH, { replace: true });
  }, [session, pathname]); // eslint-disable-line react-hooks/exhaustive-deps
};
